import { useComponentLocale } from './useComponentLocale';
export var useNameMapper = function () {
    var getLocale = useComponentLocale();
    var substrateColorLocale = getLocale({ component: 'theme', section: 'substrate_color' });
    // const eqLocale = getLocale({ component: 'common', section: 'eq' })
    // const rangeLocale = getLocale({ component: 'common', section: 'range' })
    // const evLocale = getLocale({ component: 'common', section: 'ev' })
    var minRangeLocale = getLocale({ component: 'theme', section: 'min_range' });
    var maxRangeLocale = getLocale({ component: 'theme', section: 'max_range' });
    var rangeTextColorLocale = getLocale({ component: 'theme', section: 'range_text_color' });
    // const suitsLocale = getLocale({ component: 'common', section: 'suits' })
    var borderColorLocale = getLocale({ component: 'theme', section: 'border_color' });
    // const textColorForOneLocale = getLocale({ component: 'theme', section: 'text_color_one' })
    var textColorForTwoLocale = getLocale({ component: 'theme', section: 'text_color_two' });
    var tableSignLocale = getLocale({ component: 'common', section: 'table' });
    return {
        allin: 'All in',
        check: 'Check',
        fold: 'Fold',
        call: 'Call',
        equity: 'Equity',
        eq: 'Equity',
        ev: 'EV',
        eqr: 'EQR',
        strategy: 'Strategy',
        range: 'Range',
        textcolor1playermatrix: 'One player',
        textcolor2playermatrix: textColorForTwoLocale,
        s: 'Spades',
        c: 'Clubs',
        h: 'Hearts',
        d: 'Diamonds',
        color: substrateColorLocale,
        'border color': borderColorLocale,
        cellEndColor: maxRangeLocale,
        cellInitialColor: minRangeLocale,
        cellFontColor: "".concat(rangeTextColorLocale),
        maxEquity: "100%",
        midEquity: "50%",
        minEquity: "0%",
        negEV: "Less 0.00",
        posEV: "More 0.00",
        zeroEV: "Equally 0.00",
        maxRange: "100%",
        minRange: "0%",
        table: tableSignLocale,
        chip: 'Chip',
        maxEqr: "Max EqR",
        midEqr: "100%",
        minEqr: "0%",
    };
};
